// FE-only configuration — no backend involvement. Drives the short
// "Ganpati Bappa Morya" greeting animation shown once per page-load on the
// pooja detail page, gated to specific pooja + location + language
// combinations only.
//
// Matching is against:
//   - poojaSlug: the pooja's slug, e.g. "ganesh-sthapana-and-visarjan-puja"
//   - location:  the URL location name, e.g. "Bangalore" (case-insensitive)
//   - language:  the URL language name, e.g. "Marathi" (case-insensitive)
// "*" matches anything for location/language.
//
// Add one entry per language you want a translated greeting for — the
// same pooja+location can appear multiple times, once per language.
//
// sthapanaDate / visarjanDate are plain display strings — update them
// every year; they are not computed from anything.
export const GANPATI_OVERLAY_RULES = [

];

const normalize = (value) => (value || "").toString().trim().toLowerCase();
const matches = (ruleValue, actualValue) =>
  ruleValue === "*" || normalize(ruleValue) === normalize(actualValue);

// Returns the matching rule (or null) for the given pooja slug + location
// name + language name. Falsy inputs simply mean no match, never an error —
// this must never block or throw on the pooja detail page.
export const resolveGanpatiOverlayRule = (poojaSlug, location, language) => {
  if (!poojaSlug) return null;
  return (
    GANPATI_OVERLAY_RULES.find(
      (r) => matches(r.poojaSlug, poojaSlug) && matches(r.location, location) && matches(r.language, language),
    ) || null
  );
};
